<h3 class="text-center rounded ">Admission Count Report {{heading}}</h3>
<!--{{startDate}}  {{startDate|date:'medium'}}  <br>-->
<!--{{endDate}} {{endDate|date:'medium'}}  <br>-->
<!--<button mat-raised-button color="primary" (click)="CheckData()">CHECK</button>-->
<br>
<!--<prettyjson [obj]="selectedCentres"></prettyjson>-->
<div class="d-flex justify-content-between  row">
  <div class="d-flex justify-content-end mb-2 gap-3">
    <mat-checkbox [(ngModel)]="showInactiveCentres">Show All Centres</mat-checkbox>
    <mat-checkbox [(ngModel)]="useCycles"
      matTooltip="ON: each stay is counted at the centre where it happened (ALAdmissionCycles). OFF: legacy counting — a child's whole history is attributed to their current centre.">
      Per-Stay Centre Attribution (New)
    </mat-checkbox>
  </div>
  <br>

    <div class="d-flex gap-1">

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [(ngModel)]="startDate" placeholder="Start date" (dateChange)="onStartDateChanged()">
          <input matEndDate [(ngModel)]="endDate" placeholder="End date" (dateChange)="onEndDateChanged()">
        </mat-date-range-input>
        <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <!--        <mat-form-field appearance="outline">-->
<!--            <mat-label>Centre</mat-label>-->
<!--            <mat-select [(value)]="selectedCentres" multiple>-->
<!--                <mat-option value="All">All</mat-option>-->
<!--                <mat-option *ngFor="let c of (centres$|async)" [value]="c.centreCode">{{c.centreName}}</mat-option>-->
<!--            </mat-select>-->
<!--        </mat-form-field>-->

      <app-searchable-select class="col-md-4"
                             [multiple]="true"
                             [options]="centres$ | async"
                             [selectedValue]="selectedCentre"
                             [displayWithFn]="displayCentre"
                             [placeholder]="'Select Centre'"
                             [label]="'Select Centre'"
                             (selectionChange)="onCentreSelect($event)"
      ></app-searchable-select>

        &nbsp;&nbsp;
        &nbsp;&nbsp;<button mat-mini-fab color="accent" (click)="searchByDate()" permission="Admission Report" [permissionTypes]="[PermissionType.VIEW]">
        <mat-icon>search</mat-icon>
    </button>
        &nbsp;&nbsp;<button mat-mini-fab color="accent" (click)="clearAll()" permission="Admission Report" [permissionTypes]="[PermissionType.VIEW]">
        <mat-icon>clear</mat-icon>

    </button>


        <!--    <div class="col-md-3">-->
        <!--      <button mat-raised-button (click)="exportexcel()" color="primary">-->
        <!--        <mat-icon> cloud_download</mat-icon> &nbsp; Download Table-->
        <!--      </button>-->
        <!--    </div>-->

    </div>
</div>

<div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
            <h2>Admission Count Reports</h2>
        </li>
        <li class="dropdown m-l-20">
            <label for="search-input"><i class="material-icons search-icon">search</i></label>
            <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
                   (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
    </ul>
    <ul class="header-buttons mr-2">

        <li>
            <div class="export-button m-l-10" matTooltip="XLSX"  (click)="exportexcel()">
              <img src="assets/images/icons/xlsx.png" permission="Admission Report" [permissionTypes]="[PermissionType.EXCEL]" alt="" />
            </div>
        </li>
    </ul>
</div>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table table-striped table-bordered" id="excel-table">

    <!-- Position Column -->
    <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef> Centre Name</th>
        <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
        <td mat-footer-cell *matFooterCellDef><span *ngIf="dataSource.data.length>=1">Download</span></td>

    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="new_admission">
        <th mat-header-cell *matHeaderCellDef>New Admission</th>
        <td mat-cell *matCellDef="let element"> {{element.new_admission}} </td>
        <td mat-footer-cell *matFooterCellDef>
            <button *ngIf="dataSource.data.length>=1" mat-icon-button color="accent" (click)="downloadAdmissions()">
                <mat-icon>cloud_download</mat-icon>
            </button>
        </td>

    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="discharge">
        <th mat-header-cell *matHeaderCellDef> Discharge</th>
        <td mat-cell *matCellDef="let element"> {{element.discharge}} </td>
        <td mat-footer-cell *matFooterCellDef>
            <button *ngIf="dataSource.data.length>=1" mat-icon-button color="accent" (click)="downloadDischarge()">
                <mat-icon>cloud_download</mat-icon>
            </button>

        </td>

    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="follow_up_admission">
        <th mat-header-cell *matHeaderCellDef> Follow Up Admission</th>
        <td mat-cell *matCellDef="let element"> {{element.follow_up_admission}} </td>
        <td mat-footer-cell *matFooterCellDef>
            <button *ngIf="dataSource.data.length>=1" mat-icon-button color="accent" (click)="downloadFollowUpAdmissions()">
                <mat-icon>cloud_download</mat-icon>
            </button>
        </td>

    </ng-container>

    <ng-container matColumnDef="follow_up_discharge">
        <th mat-header-cell *matHeaderCellDef> Follow Up Discharge</th>
        <td mat-cell *matCellDef="let element"> {{element.follow_up_discharge}} </td>
        <td mat-footer-cell *matFooterCellDef>
            <button *ngIf="dataSource.data.length>=1" mat-icon-button color="accent" (click)="downloadFollowUpDischarge()">
                <mat-icon>cloud_download</mat-icon>
            </button>
        </td>

    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>

    <!--    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true">-->
    <!--        <td mat-cell *matCellDef="let element">1  </td>-->
    <!--        <td mat-cell *matCellDef="let element">1  </td>-->
    <!--        <td mat-cell *matCellDef="let element">1  </td>-->
    <!--        <td mat-cell *matCellDef="let element">1  </td>-->
    <!--    </tr>-->


    <! -- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">Please select date range</td>
    </tr>
</table>
<div class="row" *ngIf="showLog">
    <div class="col-md-3">
        <h2>Admission</h2>
        <p *ngFor="let d of admissionsCountChildarray">{{d.firstName}} {{d.lastName}} - {{ d.centreName}}</p>
    </div>
    <div class="col-md-3">
        <h2>Discharge</h2>
        <p *ngFor="let d of dischargeCountChildArray">{{d.firstName}} {{d.lastName}} - {{ d.centreName}}</p>
    </div>
    <div class="col-md-3">
        <h2>Follow Up</h2>
        <p *ngFor="let d of followUpCountChildArray">{{d.firstName}} {{d.lastName}} - {{ d.centreName}}</p>
    </div>
    <div class="col-md-3">
        <h2>Follow Out</h2>
        <p *ngFor="let d of followUpOutCountChildArray">{{d.firstName}} {{d.lastName}} - {{ d.centreName}}</p>
    </div>

</div>
